var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6,
    r: 6,
    fill: "#6CB1BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13C2.244 13 .43 15.993.076 20.001-.021 21.101.896 22 2 22h16c1.105 0 2.021-.898 1.924-1.999C19.571 15.993 17.756 13 10 13z",
    fill: "#6CB1BF"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMCAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTAiIGN5PSI2IiByPSI2IiBmaWxsPSIjNkNCMUJGIi8+CjxwYXRoIGQ9Ik0xMCAxM0MyLjI0Mzg2IDEzIDAuNDI5MjIgMTUuOTkyNiAwLjA3NTc4MTkgMjAuMDAxMkMtMC4wMjEyMzIxIDIxLjEwMTUgMC44OTU0MzEgMjIgMiAyMkgxOEMxOS4xMDQ2IDIyIDIwLjAyMTIgMjEuMTAxNSAxOS45MjQyIDIwLjAwMTJDMTkuNTcwOCAxNS45OTI2IDE3Ljc1NjEgMTMgMTAgMTNaIiBmaWxsPSIjNkNCMUJGIi8+Cjwvc3ZnPgo=";
export { SvgIconUser as ReactComponent };